import OauthLoginModal from "../../components/modals/OauthLoginModal";
import { OauthRoomsConfig } from "../../features/oauth";
import { useRoomPreviewOAuthCallback } from "./useRoomPreviewOAuthCallback";

export default function RoomPreviewOAuthCallbackPage({
  roomId,
}: {
  roomId: string;
}) {
  useRoomPreviewOAuthCallback(roomId);
  const room = OauthRoomsConfig.find((config) => config.id === roomId);
  return (
    <div className="fixed inset-0 bg-secondary-bluegrey-2">
      <OauthLoginModal
        isVisible
        roomName={room === undefined ? "" : room.name}
      />
    </div>
  );
}
